import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setRestaurantAnalytics } from '../slices/restaurantSlice';
import { setTasks } from '../slices/taskSlice';
import { store } from '../store';

export const getTasks = async ({ id, filter, page = 1, ...filters }) => {
  store.dispatch(setRestaurantAnalytics({}));
  store.dispatch(
    setTasks({
      filter: filter,
      data: [],
      pagination: null,
    })
  );
  const res = await handleGetRequest(URI.restaurant_tasks, null, {
    toast: false,
    params: { restaurant_id: id, filter, page, ...filters },
  });
  if (filter === 'dashboard') {
    if (res?.ack) store.dispatch(setRestaurantAnalytics(res.data));
    else window.location.href = '/';
  } else if (res?.ack) {
    store.dispatch(
      setTasks({
        filter: filter,
        data: res.data,
        pagination: res.pagination || null,
      })
    );
  }
  return res;
};

export const createTask = async (body) => {
  const res = await handlePostRequest(URI.restaurant_tasks, body);
  return res;
};

export const updateTask = async (id, body, { toast = true, loading = true }) => {
  const res = await handlePutRequest(URI.tasks_by_id(id), body, {
    toast,
    loading,
  });
  return res;
};

export const deleteTask = async (id) => {
  const res = await handleDeleteRequest(URI.tasks_by_id(id));
  return res;
};

export const updateTaskProgress = async (id, body, { toast = true, loading = true }) => {
  const res = await handlePutRequest(URI.tasks_progress_by_id(id), body, {
    toast,
    loading,
  });
  return res;
};

export const undoTaskCompletion = async ({ taskId, restaurant_id, filter }) => {
  const res = await updateTaskProgress(taskId, { progress: 0 }, { toast: false });
  if (res.ack) {
    getTasks({ id: restaurant_id, filter });
  }
  return res;
};

export const getTaskById = async ({ taskId }) => {
  const res = await handleGetRequest(URI.tasks_by_id(taskId));
  return res;
};

export const getTaskActivities = async ({ taskId }) => {
  const res = await handleGetRequest(URI.tasks_activities_by_id(taskId), null, { toast: false, loading: false });
  return res;
};

export const moveOrCopyTask = async (id, body) => {
  const res = await handlePostRequest(URI.task_move_copy(id), body);
  return res;
};
